import React, { useEffect } from "react";
import Layout from "../Layout";
import "./App.module.scss";
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import MainProvider from "../../context";
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { loginRequest, msalInstance } from "../../misc/msal.config";

const App: React.FC = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <AuthenticatedTemplate>
        <AuthenticatedContent />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <AnonymousContent />
      </UnauthenticatedTemplate>
    </MsalProvider>
  );
};

const AuthenticatedContent: React.FC = () => {
  return (
    <SnackbarProvider hideIconVariant={true} className="notification-provider">
      <MainProvider>
        <BrowserRouter>
          <Layout />
        </BrowserRouter>
      </MainProvider>
    </SnackbarProvider>
  );
};

const AnonymousContent: React.FC = () => {
  const { instance } = useMsal();

  useEffect(() => {
    if (!instance.getActiveAccount()) instance.loginRedirect(loginRequest);
  });

  return <></>;
};

export default App;
